<template>
  <v-layout class="rights" row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >        
    <v-flex xs12 class="px-1">            
      <v-card class="card--flex-toolbar" >
         <v-toolbar card extended>
            <v-toolbar-title>{{$t('Admin.AdminMission.Rights.UserRole')}}</v-toolbar-title>
            <template v-slot:extension>
              <v-autocomplete class="mr-2"
              :items="users"
              :item-text="(u)=> `${u.libelle} (${enseignesById[u.ENS_ID].ENS_LIBELLE})`"
              item-value="USR_ID"
              :label="$t('Admin.AdminMission.Rights.UserToSelect')"
              v-model="usrId"
            ></v-autocomplete>
              <v-select 
              :items="roles"
              item-text="ROL_LIBELLE"
              item-value="ROL_KEY"
              :label="$t('Admin.AdminMission.Rights.RoleToAdd')"
              v-model="usrRoleKey"
            ></v-select>
            <v-spacer></v-spacer>
              <v-btn :disabled="usrId == -1 || usrRoleKey == ''" @click="addMissionMappingRole">
                {{$t('Admin.AdminMission.Rights.AddRole')}}
              <v-icon right >mdi-plus-circle</v-icon>
            </v-btn>
          </template>
        </v-toolbar>               
            <v-data-table              
              :headers="usersRoleHeaders"
              :items="missionRolesMapping"
              class="elevation-0"
              hide-actions       
              :loading="adminMissionRoleMappingLoading"
              :no-data-text="$t('Admin.AdminMission.Rights.NoSpecificUserRole')"       
            >
              <template v-slot:items="props">                
                <td style="text-align:left">{{ usersById[props.item.key].libelle }}  ({{enseignesById[usersById[props.item.key].ENS_ID].ENS_LIBELLE}})</td>
                <td class="text-xs-right"><v-chip v-for="mapping in props.item.values" :key="mapping.ROL_ID" close @input="removeMappingRole(mapping)">{{rolesByKey[mapping.ROL_KEY].ROL_LIBELLE}}</v-chip></td>
              </template>
            </v-data-table>              
      </v-card> 
    </v-flex>                                  
  </v-layout>   
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch} from 'vue-property-decorator'
import { AloDbRoleMapping } from '../../../models/alodb/AloDbRoleMapping'
import { groupBy } from '@/utils/groupBy'  

@Component({
  name: 'AdminUserRights'
})
export default class AdminUserRights extends Vue {  
    
  public usrId:number = -1
  public usrRoleKey:string = ""
  public usersRoleHeaders = [
          {
            text: 'User',
            align: 'left',
            sortable: false,   
            width:"1000"
          },
          {
            text: 'Roles',
            align: 'right',
            sortable: false,
            width:"2000"               
          }
        ]  

   /*Cycle de vie*/
  created() {           
    this.$store.myActions.ROLE_ENSURE_LIST()
    this.$store.myActions.USER_ENSURE_LIST()
    this.$store.myActions.ENSEIGNE_ENSURE_LIST()
    if(this.mis_id) this.ensureRoleMappings()
  }
  
  
  ensureRoleMappings() {
    this.$store.myActions.ADMINMISSION_ENSURE_ROLEMAPPING({itemId:this.mis_id,explicit:true})
  }

  addMissionMappingRole() {
    this.$store.myActions.USER_ADD_ROLEMAPPING_REQUEST({
      usrId:this.usrId,
      mapObject:'mission',
      mapId:this.mis_id,
      rolKey:this.usrRoleKey
    })    
  }


  removeMappingRole(mapping:AloDbRoleMapping) {
    this.$store.myActions.USER_REMOVE_ROLEMAPPING_REQUEST({
          usrId:mapping.USR_ID!,
          mapObject:mapping.MAP_OBJECT!,
          mapId:mapping.MAP_ID!,
          rolKey:mapping.ROL_KEY!
        })
  }  

  get missionRolesMapping(){
    return  groupBy((this.$store.myGetters.modifiedAdmAdminMissionRolesMapping as Array<AloDbRoleMapping>) ?? [], grpKey => grpKey?.USR_ID?.toString()!) 
  }
  
  get original() {
    return this.$store.myGetters.originalAdmAdminMission
  }
  
  get enseignesById(){
    return this.$store.myGetters.enseignesById
  }
  
  get mis_id() {
    return this.original.MIS_ID!
  }

  @Watch('mis_id')
  onMisIdChanged(to: string, oldVafroml: string) {
    this.ensureRoleMappings()
  }

  get roles() {
    return this.$store.myGetters.roles
  }

  get rolesByKey(){
    return this.$store.myGetters.rolesByKey
  }
  
  get users() {
    return this.$store.myGetters.users
  }

  get usersById() {
    return this.$store.myGetters.usersById
  }

  get adminMissionRoleMappingLoading(){
    return this.$store.myGetters.adminMissionRoleMappingLoading || this.$store.myGetters.roleMappingLoadingByType('mission')
  }  

}
</script>
<style>
.rights .v-table__overflow,.rights .v-datatable{
  overflow-x:hidden;
}
</style>